import { SITE_METADATA } from "./siteMetadata";

export const WEBSITE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: SITE_METADATA.title,
  url: SITE_METADATA.url,
  description: SITE_METADATA.description,
} as const;
